import React from "react";
import Icon from "react-icon-base";

const SearchIcon = props => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g className="nc-icon-wrapper">
      <path d="M23.245 23.996a.743.743 0 0 1-.53-.22L16.2 17.26a9.824 9.824 0 0 1-2.553 1.579 9.766 9.766 0 0 1-7.51.069 9.745 9.745 0 0 1-5.359-5.262c-1.025-2.412-1.05-5.08-.069-7.51S3.558 1.802 5.97.777a9.744 9.744 0 0 1 7.51-.069 9.745 9.745 0 0 1 5.359 5.262 9.748 9.748 0 0 1 .069 7.51 9.807 9.807 0 0 1-1.649 2.718l6.517 6.518a.75.75 0 1 1-.531 1.28zM9.807 1.49a8.259 8.259 0 0 0-3.25.667 8.26 8.26 0 0 0-4.458 4.54 8.26 8.26 0 0 0 .058 6.362 8.26 8.26 0 0 0 4.54 4.458 8.259 8.259 0 0 0 6.362-.059 8.285 8.285 0 0 0 2.594-1.736.365.365 0 0 1 .077-.076 8.245 8.245 0 0 0 1.786-2.728 8.255 8.255 0 0 0-.059-6.362 8.257 8.257 0 0 0-4.54-4.458 8.28 8.28 0 0 0-3.11-.608z" />
    </g>
  </Icon>
);
export default SearchIcon;
